import React from "react";
import Breadcrums from "../components/breadcrums";
import OverdueEmail from "../components/overdue-email";
import logger from "../utils/logger";

const breadcrumLinks = [{ name: "Home", href: "/dashboard", current: true }];

export default function Dashboard() {
    // const userData = useContext(UserContext); // Removed unused variable

    // Helper to check if today is the last day of the month
    const isMonthEnd = () => {
        const today = new Date();
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        return today.getDate() === lastDay;
    };

    // Auto-send email at month end
    // useEffect(() => {
    //     if (isMonthEnd()) {
    //         // sendEmail removed: not imported and not required here
    //     }
    // }, []);

    // Overdue invoice logic moved to OverdueEmail component

    const testLogger = () => {
        logger.info("Test info log from dashboard", { source: "dashboard-test" });
        logger.warn("Test warning log from dashboard", { source: "dashboard-test" });
        logger.error("Test error log from dashboard", { source: "dashboard-test" }, new Error("Simulated error for Vercel logging test"));
    };

    const testUnhandled = () => {
        throw new Error("Simulated unhandled exception — Vercel error tracking should capture this");
    };

    const testRejection = () => {
        Promise.reject(new Error("Simulated unhandled promise rejection — Vercel error tracking should capture this"));
    };

    return (
        <main>
            {/* Overdue Email Button as Independent Component */}
            {/* <OverdueEmail /> */}
            <Breadcrums breadcrumLinks={breadcrumLinks} module={"Home"} />
            {/* Welcome Section */}
            <section className="min-h-screen px-4 py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
                <div className="max-w-4xl mx-auto mb-20 text-center">
                    <h1 className="mb-6 text-5xl font-bold text-gray-900 md:text-6xl">Welcome to MTOPs - Mind Tech OPS</h1>
                    <p className="mb-12 text-xl text-gray-600">Driving business and technology transformation with specialized consulting, solutions, services and products.</p>
                    <a href="https://mindtechinc.com" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-3 font-semibold text-white transition duration-300 bg-blue-600 rounded-lg hover:bg-blue-700">
                        Learn more about Mind Tech Inc. →
                    </a>
                </div>

                {/* Features Grid */}
                <div className="grid max-w-6xl grid-cols-1 gap-12 mx-auto md:grid-cols-3">
                    {/* Feature 1 */}
                    <div className="text-left">
                        <h3 className="mb-3 text-2xl font-bold text-gray-900">Operational Insights</h3>
                        <p className="text-gray-600">Get a clear view of ongoing operations and system performance.</p>
                    </div>

                    {/* Feature 2 */}
                    <div className="text-left">
                        <h3 className="mb-3 text-2xl font-bold text-gray-900">Platform Management</h3>
                        <p className="text-gray-600">Control users, processes, and integrations from a centralized dashboard.</p>
                    </div>

                    {/* Feature 3 */}
                    <div className="text-left">
                        <h3 className="mb-3 text-2xl font-bold text-gray-900">Requests & Support</h3>
                        <p className="text-gray-600">Submit, track, and resolve internal requests with ease.</p>
                    </div>
                </div>

                {/* Logger Test Section */}
                <div className="max-w-4xl mx-auto mt-16 p-6 bg-white rounded-lg shadow-sm border border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-900 mb-2">Vercel Logger Test</h2>
                    <p className="text-sm text-gray-500 mb-4">Click buttons to generate test logs visible in Vercel's error tracking and browser console.</p>
                    <div className="flex flex-wrap gap-3">
                        <button onClick={testLogger} className="px-4 py-2 text-sm font-medium text-white bg-blue-900 rounded hover:bg-blue-700">
                            Log info / warn / error
                        </button>
                        <button onClick={testUnhandled} className="px-4 py-2 text-sm font-medium text-white bg-red-700 rounded hover:bg-red-600">
                            Throw unhandled exception
                        </button>
                        <button onClick={testRejection} className="px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded hover:bg-orange-500">
                            Unhandled promise rejection
                        </button>
                    </div>
                </div>
            </section>
            {/* <section>
                <h1>{JSON.stringify(userData)}</h1>
            </section> */}
        </main>
    );
}
